import { createJSONStorage } from 'jotai/utils';
import type { SyncStringStorage } from 'jotai/vanilla/utils/atomWithStorage';
import Cookies from 'js-cookie';

export const CookieStorage: SyncStringStorage = {
  getItem: key => {
    const cookieValue = key && Cookies.get(key);
    return cookieValue ? cookieValue : null;
  },
  setItem: (key, value) => {
    if (value === null || value === undefined) {
      Cookies.remove(key);
    } else {
      Cookies.set(key, value, { expires: 300 });
    }
  },
  removeItem: key => {
    Cookies.remove(key);
  },
};

/**
 * For handling storing of more complex data where you would use JSON.parse or JSON.stringify
 * @param initialValue
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function createCookieStorage<T>(_initialValue: T) {
  return createJSONStorage<T>(() => ({
    ...CookieStorage,
  }));
}
